import React from 'react';

// TYPES
import { Pagination } from 'react-bootstrap';
import SvgMask from '../_Helpers/SvgMask';

interface PropsType {
	pageNumber: number;
	totalPages: number;
	pageSwitchCallback: (newPageNumber: number) => void;
	resultsReloading?: boolean;
}

const PaginationCustom: React.FC<PropsType> = ({
	pageNumber,
	totalPages,
	pageSwitchCallback,
	resultsReloading = false
}) => {
	return (
		<Pagination className="pagination-custom">
			<Pagination.Item
				onClick={() => pageSwitchCallback(pageNumber - 1)}
				linkClassName={`${totalPages === 1 || pageNumber === 1 || resultsReloading ? 'disabled' : ''}`}
			>
				<SvgMask path="/svg/chevron-left.svg" width={24} height={24} />
			</Pagination.Item>

			{pageNumber - 1 !== 1 && pageNumber !== 1 ? (
				<>
					<Pagination.Item
						onClick={() => pageSwitchCallback(1)}
						linkClassName={`${resultsReloading ? 'disabled' : ''}`}
					>
						1
					</Pagination.Item>
					{pageNumber - 2 !== 1 ? <Pagination.Ellipsis linkClassName="" /> : null}
				</>
			) : null}

			{!(pageNumber - 1 < 1) ? (
				<Pagination.Item
					onClick={() => pageSwitchCallback(pageNumber - 1)}
					linkClassName={`${resultsReloading ? 'disabled' : ''}`}
				>
					{pageNumber - 1}
				</Pagination.Item>
			) : null}

			<Pagination.Item linkClassName={` active ${resultsReloading ? 'disabled' : ''}`}>{pageNumber}</Pagination.Item>

			{!(pageNumber + 1 > totalPages) ? (
				<Pagination.Item
					onClick={() => pageSwitchCallback(pageNumber + 1)}
					linkClassName={`${resultsReloading ? 'disabled' : ''}`}
				>
					{pageNumber + 1}
				</Pagination.Item>
			) : null}

			{pageNumber + 1 !== totalPages && pageNumber !== totalPages ? (
				<>
					{pageNumber + 2 !== totalPages ? (
						<Pagination.Ellipsis linkClassName={`pe-none  ${resultsReloading ? 'disabled' : ''}`} />
					) : null}

					<Pagination.Item
						onClick={() => pageSwitchCallback(totalPages)}
						linkClassName={`${resultsReloading ? 'disabled' : ''}`}
					>
						{totalPages}
					</Pagination.Item>
				</>
			) : null}

			<Pagination.Item
				onClick={() => pageSwitchCallback(pageNumber + 1)}
				linkClassName={`${totalPages === 1 || pageNumber === totalPages || resultsReloading ? 'disabled' : ''}`}
			>
				<SvgMask path="/svg/chevron-right.svg" width={24} height={24} />
			</Pagination.Item>
		</Pagination>
	);
};

export default PaginationCustom;
